<template>
  <div class="float-dialog-wrap">
    <div v-if="firstOrder" class="first-order-redbag">
      <div class="first-order-inner">
        <button class="first-order-btn" @click="jumpNewer"></button>
        <i @click="closeFirstOrder" class="close-btn"></i>
      </div>
    </div>
    <!-- <div v-else-if="masterMusk" class="master-musk">
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    masterMusk: {
      type: Boolean,
      default: false,
    },
    firstOrder: {
      type: Boolean,
      default: false,
    },
    inviterUuid: String
  },
  computed: {
    ...mapGetters(['userInfo', 'showAdBox', 'accountInfo']),
  },
  methods: {
    closeAdBtn() {
      this.$store.dispatch('app/toggleAdBox', false)
    },
    jumpLogin() {
      this.$util.Login()
    },
    closeFirstOrder() {
      this.firstOrder = false
    },
    jumpNewer() {
      this.firstOrder = false
      this.$router.push({
        name: 'MasterDetail',
        params: {
          uuid: this.inviterUuid
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .title-1 {
    font-size: 24px;
    line-height: 34px;
    color: #FEEAB7;
    margin-top: 99px;
    text-align: center;
  }
  .title-2 {
    font-size: 24px;
    line-height: 34px;
    color: #FEEAB7;
    text-align: center;
  }
  .discount-price {
    margin-top: 70px;
    display: flex;
    justify-content: center;
    font-weight: 800;
    font-size: 36px;
    line-height: 72px;
    text-align: center;
    color: #FA006E;
    .amount {
      font-size: 120px;
      line-height: 120px;
      margin-left: 7px;
    }
  }
  .float-dialog-wrap {
    .ad-dialog-tip {
      position: fixed;
      width: 320px;
      height: 320px;
      right: 0;
      bottom: 0;

      .ad-dialog-img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }

      .add-close-close {
        position: absolute;
        top: 0;
        right: 0;
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }

    .use-reward {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      @include flex();
      background: rgba(0, 0, 0, 0.6);
      z-index: 100;

      .reward-box-inner {
        width: 570px;
        height: 570px;
        background: url('~@/assets/image/background/newer-reward-bg.png') no-repeat center center;
        background-size: contain;
        > div {
          margin: 0 auto;
        }

        .reward-btn {
          margin: 70px auto 0;
          display: block;
          width: 162px;
          height: 56px;
          background: url('~@/assets/images/reward-confirm-btn.png') no-repeat center center;
          background-size: contain;
        }

        p {
          text-align: center;
          font-size: 12px;
          margin-top: 6px;
          color: rgba(255, 255, 255, 0.7);
        }

        .close-btn {
          display: block;
          width: 37px;
          height: 37px;
          margin: 100px auto 0;
          background: url('~@/assets/image/icons/close-icon-border.png') no-repeat center center;
          background-size: contain;
        }
      }
    }
    .first-order-redbag {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      @include flex();
      z-index: 2;
      background: rgba(0, 0, 0, 0.6);
      .first-order-inner {
        width: 473px;
        height: 483px;
        background:  url('~@/assets/images/first-order.png') no-repeat center center;
        background-size: contain;
        position: relative;
        bottom: 100px;
        .first-order-btn {
          width: 162px;
          height: 52px;
          display: block;
          margin: 350px auto 120px;
          cursor:pointer;
        }
        .close-btn {
          display: block;
          width: 37px;
          height: 37px;
          margin: 0 auto;
          background: url('~@/assets/image/icons/close-icon-border.png') no-repeat center center;
          background-size: contain;
          cursor: pointer;
        }
      }

    }
    .master-musk {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      @include flex();
      z-index: 2;
      background: rgba(0, 0, 0, 0.6);
      img {
        position: absolute;
        width: 635px;
        height: 147px;
        top: 370px;
        left: 710px;
      }
    }
  }
  .float-dialog-wrap {
    .use-reward {
      .reward-box-inner {
        background-size: 100vw 100vw;

        > div {
          margin-top: 247px;
        }
      }
    }
  }
</style>